module.exports = __webpack_public_path__ + "static/media/image1.5f181d34.png";